export const tagTokens = {
  'tag-height': '24px',
  'tag-padding-x': 'var(--dp-spacing-sm)',
  'tag-font-size': 'var(--dp-font-size-sm)',
  'tag-font-weight': 'var(--dp-font-weight-medium)',
  'tag-border-radius': 'var(--dp-border-radius-full)',
  'tag-bg': 'var(--dp-color-surface)',
  'tag-text-color': 'var(--dp-color-text)',
  'tag-border-color': 'var(--dp-color-border)',
  'tag-close-size': '14px',
  'tag-close-hover-bg': 'var(--dp-color-surface-hover)',
  'tag-gap': 'var(--dp-spacing-xs)',
} as const;
